const DEFAULT_DURATION_FALLBACK = 30;

export default function getDefaultEventDuration(): number {
    return DEFAULT_DURATION_FALLBACK;
}
